

































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import {IEditor, Editor,CustomDirectEditProvider} from '@/agiles/common/validator';

@Component
export default class ReceivePaymentView extends Vue {
  public items: Common.Payment[] = new Array(0);
  public params: Common.PaymentQuery = new Common.PaymentQuery(Common.PaymentFlags.Receive);
  public importQuery = new Common.PaymentImportQuery('入金',false);
  public exportQuery = new Common.PaymentExportQuery('入金',this.params,false);
  public sortOptions: any = [
    { value: 'State', text: '状態' },
    { value: 'paymentNo', text: '入金番号' },
    { value: 'counterpart', text: '得意先' },
    { value: 'bookDate', text: '入金日' },
    { value: 'bankAccount', text: '入金口座' },
    { value: 'segment', text: '部門' },
    { value: 'paymentFlag', text: '入金区分' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];
  @Prop() public paymentNo:string;

  public Common = Common;
  public hasLicenseCurrency: boolean = false;
  // 一覧可変表示用プロパティ  
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([], 0, 'grid');
  public taxTypes = Common.TaxTypes;
  public paymentStatus = Common.PaymentStatus;
  public moneylookStartDate: Date = null;
  public moneylookEndDate: Date = null;

  public created() {
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    //'状態', '入金番号','ワークフロー', '部門', '担当者', '得意先', '取引通貨', '入金日', '入金口座', '口座入金額',
    // '手数料額', '決済金額', '入金額合計',  '入金区分',  '初回保存日', '初回保存者', '最終更新日', '最終更新者'
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 100),
      new Common.GridItemConfiguration('入金番号', 120),      
      new Common.GridItemConfiguration('ワークフロー', 180),      
      new Common.GridItemConfiguration('得意先', 150),
      new Common.GridItemConfiguration('入金日', 150),
      new Common.GridItemConfiguration('入金口座', 150),            
      new Common.GridItemConfiguration('取引通貨', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('決済金額', 150),
      new Common.GridItemConfiguration('手数料額', 150),
      new Common.GridItemConfiguration('前受金残高', 150),
      new Common.GridItemConfiguration('前受金消込額(確定待ち)', 150),
      new Common.GridItemConfiguration('手数料税区分', 180),
      new Common.GridItemConfiguration('口座入金額', 150),
      new Common.GridItemConfiguration('入金レート', 150,this.hasLicenseCurrency),         
      new Common.GridItemConfiguration('入金区分', 150),
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),      
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),            


    );
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;

    // 検索条件を設定する
    if(this.paymentNo) {
      this.params.paymentNo = this.paymentNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
    }
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
  }
  

  //消込明細のダイレクトエディットサポートをするためのエディタ
  public originalJournals: Array<Common.TransferJournal> = null;
  public getJournalEditor(isSuspense:boolean){

    var getter: ()=>Array<Common.TransferJournal> = () =>isSuspense == false ? this.journals : this.suspenseJournals;
    var setter:(items:Array<Common.TransferJournal>) =>void = items => {
      if(isSuspense == false) this.journals = items; 
      else this.suspenseJournals = items;
      };

    var listView = this.$refs.mainList as Components.ListView;
    var editor = new Editor();
    editor.isEdit = false;
    editor.owner = new CustomDirectEditProvider();
    editor.owner.onDirectEdit = () => {
      this.originalJournals = getter();
      setter(this.$api.createBinder('TransferJournal',true).loadInstance(this.originalJournals));
    };    
    editor.owner.onDirectCommit = () => {
        var items = getter().filter((obj,index) => obj.amountFC != this.originalJournals[index].amountFC);
        this.$api.execute(new Common.PaymentJournalUpdateQuery(listView.selected,isSuspense, false, items))
        .then(res =>{this.$set(this.items, listView.currentId, res);})
        .catch(res => {setter(this.originalJournals)});        //エラーが出た場合は元戻し
    };
    editor.owner.onDirectClose = () =>{
      //ロールバック
      setter(this.originalJournals);
    }; 
    editor.owner.hasDirectPerm = () => {
      var editable =  isSuspense ? listView.selected.state != Common.PaymentStatus.ReceiptPostWaiting:  listView.selected.state == Common.PaymentStatus.ReceiptPostWaiting
      return editable && this.$api.perms.hasWorkflowPermission(listView.selected.workflowHolder);
    };    

    return editor;
  }



  public async onCreate(obj: Common.Payment) {
    const workflows = this.$api.formatter.getOptions('workflow_receivePayment');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.paymentFlag = Common.PaymentFlags.ReceiveAloneInvoice;
    obj.exchangeRate = 1;
    obj.currencyCode = this.$api.tenantSettings.currencyCode;    
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.items[index] =  (this.$refs.mainList as Components.ListView).selected as Common.Payment;
    this.$set(this.items, index, obj);
  }

  // 一覧選択時に明細一覧タブを更新
  public onSelectedMain(index: number, selected: Common.Payment) {
    // 明細一覧タブを更新
    this.journals = new Array(0);
    this.suspenseJournals = new Array(0);
    if(index >= 0) this.refreshChargeItemtList();
  }

  public isEditable(item: Common.Payment){
    //支払消込がないこと
    return item.state == Common.PaymentStatus.ReceiptPostWaiting && (item.paymentBalance == null ||  item.paymentBalance.debitJournals.length == 0);
  }


  // 明細一覧タブ更新用プロパティ
  public isLoading: boolean = false;
  public journals: Common.TransferJournal[]= new Array(0);
  public suspenseJournals: Common.TransferJournal[] = new Array(0);

  // 明細一覧タブを更新
  public refreshChargeItemtList(){
    var payment = (this.$refs.mainList as Components.ListView).selected as Common.Payment;
    // クエリを設定する
    var query = new Common.TransferJournalQuery();
    query.payment = (this.$refs.mainList as Components.ListView).selected;

    // サーバーから明細を取得する
    this.isLoading = true;
    this.$api.execute(query).then(res => {
      res = res as Common.LoadResult;
      this.suspenseJournals = (res.result as Array<Common.TransferJournal>).filter(obj =>obj.journalType == Common.TransferJournalTypes.AccountReceivable_SuspenseWriteoff);
      this.journals = (res.result as Array<Common.TransferJournal>).filter(obj =>obj.journalType != Common.TransferJournalTypes.AccountReceivable_SuspenseWriteoff);      
      // payment.transferJournals = this.journals;=>個別更新に変更
    }).finally(()=>{
      this.isLoading = false;
    });
  }

  public  onChangeAmountFC(){
    if((this.$refs.mainEditor as Components.Editor).isEdit == false) return;
    var payment = (this.$refs.mainList as Components.ListView).selected as Common.Payment;
    payment.amountFC = payment.settlementAmountFC - payment.commissionAmountFC;
    // payment.transferJournals = this.journals;
    // if(this.journals.length > 0){
    //   payment.settlementAmountFC = this.journals.map(obj => obj.amountFC).reduce((total, value) => total + value);
    // }
    // else{
    //   payment.settlementAmountFC = 0;
    // } 
    // payment.amountFC = payment.settlementAmountFC - payment.commissionAmountFC;
  }

  public onChangeBankAccount(){
    if((this.$refs.mainEditor as Components.Editor).isEdit == false) return;
    var payment = (this.$refs.mainList as Components.ListView).selected as Common.Payment;
    if(payment.bankAccount != null) payment.commissionTaxCode = payment.bankAccount.taxSystemCurrencyFee;
  }

  // 伝票へ遷移する
  public onPaymentNoClick(paymentNo: string){
    var flag = ((this.$refs.mainList as Components.ListView).selected as Common.Payment).paymentFlag;
    if (flag == Common.PaymentFlags.ReceiveSalesOrder)
      this.$router.push(String.format('/sales/SalesOrder?orderNo={0}',paymentNo));
    else if (flag == Common.PaymentFlags.ReceiveAloneInvoice)
      this.$router.push(String.format('/sales/AloneInvoice?invoiceNo={0}',paymentNo));
    else if (flag == Common.PaymentFlags.ReceiveCarryOverInvoice)    
      this.$router.push(String.format('/sales/CarryOverInvoice?invoiceNo={0}',paymentNo));    
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.Payment){
    if (item.paymentFlag == Common.PaymentFlags.ReceiveSalesOrder)
      this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesOrderPayment, sourceNo : item.paymentNo},this.$el);
    else
      this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesPayment, sourceNo : item.paymentNo},this.$el);
  }    


  //入金処理
  public writeoffIsSuspense:boolean = false;
  public suspenseAmountFC:number = 0;
  public showWriteoffDialog(item: Common.Payment, isSuspense:boolean){

    this.writeoffIsSuspense = isSuspense;
    this.suspenseAmountFC = item.suspenseAmountFC;
    this.$api.execute(new Common.PaymentJournalTargetQuery(item,isSuspense)).then(res=>{
      var dialog = this.$refs.writeoffDialog as Components.ListDialog;
      dialog.items = res as Array<Common.TransferJournal>;
      dialog.showDialog();
    });
  }
  public async submitWriteoffDialog(list: Array<Common.TransferJournal>){
    // 実行前バリデーション
    var items = list.filter(obj =>obj.amountFC !=0);
    if(items.length ==0){
      this.$api.modal.show('', String.format('{0}を指定してください。',this.writeoffIsSuspense ? '前受金額':'入金額'), true, null);
      return;
    }    
    var listView = this.$refs.mainList as Components.ListView;
    this.$api.execute(new Common.PaymentJournalUpdateQuery(listView.selected,this.writeoffIsSuspense, false, items)).then(res =>{
      this.$set(this.items, listView.currentId, res);
    });
  }
  //入金削除
  public submitWriteoffDelete(isSuspense:boolean){
      var listView = this.$refs.mainList as Components.ListView;
      var items = isSuspense ? (this.$refs.suspenseJournalListBox as Components.Grid).selectedItems:(this.$refs.transferJournalListBox as Components.Grid).selectedItems;
      if (items.length == 0) {
        this.$api.modal.show('無効な操作','削除対象を選択してください。',true,null);
        return;
      }

      this.$api.modal.showDialog('確認メッセージ',String.format('{0}件の{1}を削除してよろしいですか？',items.length, isSuspense ? '前受金':'入金'),false).then(()=>{
        this.$api.execute(new Common.PaymentJournalUpdateQuery(listView.selected,isSuspense, true, items)).then(res =>{
          this.$set(this.items, listView.currentId, res);
        });        
      });
  }
  public showGetMoneyLookItemDialog(){
    if(!this.$api.tenantSettings.moneyLookOauthToken){
      this.$api.modal.show('無効な操作','MoneyLookとの連携が設定されていません。テナント設定の【入金連携認証】を実施してください。\r\n入金連携の詳細については、以下のサポートサイトをご参照ください。',true,null,[new Common.ModalLink('入金連携（MoneyLook）の設定方法と操作方法','https://support.s-flow.net/ja/articles/8000208',true)]);
      return;
    }
    if(this.$api.tenantSettings.cooperateSegment == null){
      this.$api.modal.show('無効な操作','連携部門が未設定です。テナント設定の入金連携(MoneyLook)設定【連携部門】設定してください。\r\n入金連携の詳細については、以下のサポートサイトをご参照ください。',true,null,[new Common.ModalLink('入金連携（MoneyLook）の設定方法と操作方法','https://support.s-flow.net/ja/articles/8000208',true)]);
      return;
    }
    this.moneylookStartDate = this.$api.tenantSettings.lastTransDate ?? new Date().getCalendarDate();
    this.moneylookEndDate = new Date().getCalendarDate();
    // ダイアログを表示
    (this.$refs.showMoneyLookDialog as Components.ListDialog).showDialog();
  }
  public onExecuteMoneyLookApi(){
    (this.$refs.showMoneyLookDialog as Components.ListDialog).closeDialog();
    var query = new Common.GetMoneyLookPaymentQuery();
    query.startDate = this.moneylookStartDate.getCalendarDate();
    query.endDate = this.moneylookEndDate.getCalendarDate();
    return this.$api.execute(query).then(res => {
      // テナント設定をリロードする
      this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => {
        this.$api.tenantSettings=res;
      });
      //リストリロード
      (this.$refs.mainList as Components.ListView).reload();
      this.$api.modal.show('処理結果','API連携が完了しました。\r\n結果はシステムログで確認できます。',true,null,[new Common.ModalLink('システムログに移動','/operation/SystemLog')]);
      return true;
    }).catch(()=>{return true;});
  }

  // 選択されている入金伝票の取得
  public checkedPayments: Array<Common.Payment> = new Array(0);
  public getCheckedPayments() {
    this.checkedPayments = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((item, index)=> {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        this.checkedPayments.push(item);
      }
    });
  }

  // 一括消込処理
  public async showBulkWriteOffDialog() {
    this.getCheckedPayments();
    if (this.checkedPayments.length == 0) {
      this.$api.modal.show('', '消込対象の伝票をチェックしてください', true, null);
      return;
    }
    // 入金確定待ち以外が選択されていたらメッセージ
    if (this.checkedPayments.some(payment => (payment.state & (Common.PaymentStatus.ReceiptCompleted | Common.PaymentStatus.ReceiptClosed)) != Common.PaymentStatus.Receipt)) {
      this.$api.modal.show('', '「入金確定待ち」の入金伝票を選択してください', true, null);
      return;
    }
    // クエリの実行と画面の更新
    this.$api.execute(new Common.BulkPaymentJournalUpdateQuery(this.checkedPayments)).then((res) => {
      (this.$refs.mainList as Components.ListView).reload();
      this.$api.modal.showDialog('処理結果', `${this.checkedPayments.length}件中 ${res.length}件 処理が完了しました。`);
    }).catch(()=>{return false;});
  }
}
